import React, { lazy } from "react";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import AccountSettings from "./Pages/Account/AccountSettings";
import Contactus from "./Pages/Contact us/Contactus";
import ForgotPassword from "./Pages/ForgotPassword";
import HelpingPageLayout from "./Pages/HelpingPage/HelpingPageLayout";
import FontNewUser from "./Pages/NewUser/NewUserComponent/FontNewUser";
import LayoutNewUser from "./Pages/NewUser/NewUserComponent/LayoutNewUser";
import PrivacyPolicy from "./Pages/Privacy/PrivacyPolicy";
import MoreInfoPage from "./Pages/ProjectV2/Render/MoreInfoPage";
import RenderLibrary from "./Pages/ProjectV2/Render/RenderLibrary/RenderLibrary";
// import Success from "./Pages/ProjectV2/Render/Success";
import NewSignup from "./Pages/Register/NewSignup";
import Term_and_condition from "./Pages/Terms & Conditions/Term_and_condition";
import AllPlansList from "./Pages/UserPlan/AllPlansList";
import PaymentsDetails from "./Pages/UserPlan/PaymentsDetails";
import { Dashboard, NewLogin, ProjectDashboard } from "./Pages/index";
import { logOutBroadCast } from "./Pages/utils/global";
import UnderMaintainance from "./UnderMaintainance";
import UnderMaintainance2 from "./UnderMaintainance2";
import Success from "./Pages/UserPlan/Success";
const SurveyForm = lazy(() => import("./Pages/NewUser/SurveyForm"));

const isAuthenticated = () =>
   localStorage.getItem("authToken") ? true : false;
const hasUserFilled = () => JSON.parse(localStorage.getItem("userFilledSurvey"));
function PrivateOutlet() {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/" />;
}
function PublicOutlet() {
  return !isAuthenticated() ? <Outlet /> : <Navigate to="/dashboard" />;
}

function SurveyOutlet() {
  return hasUserFilled() === true ? <Navigate to="/dashboard" /> : <Outlet />;
}
export default function Router() {
  React.useEffect(() => {
    logOutBroadCast();
  }, []);

  return (
    <div className="DIvRoute w-full h-full">
      <Routes>
        <Route path="/" element={<PrivateOutlet />}>
          {/* <Route exact path="dashboard" element={<UnderMaintainance2 />} /> */}
          <Route exact path="dashboard" element={<Dashboard />} />
          {/* <Route exact path="home/dashboard" element={<Dashboards />} /> */}
          <Route exact path="account-settings" element={<AccountSettings />} />

          <Route path="/more_info" element={<MoreInfoPage/>} />
          <Route exact path="user-plans" element={<AllPlansList />}/>
          <Route exact path="user-plan/plan&payment-details" element={<PaymentsDetails />}/>
          <Route path="/paymentsuccess" element={<Success />} />          
                  
          <Route exact path="dashboard/myrenders" element={<RenderLibrary />} />

          <Route exact path="dashboard/card/:projectId" element={<ProjectDashboard />}/>
          <Route exact path="dashboard/scroll/:projectId" element={<ProjectDashboard />}/>
          
          <Route path="/" element={<Navigate to="dashboard" />} />
          <Route path="*" element={<Navigate to="dashboard" />} />
          
          <Route path="/dashboard/new-user" element={<Dashboard />} />
          {/* <Route path="/dashboard/projectInstructions" element={<ProjectInstructions />}/> */}
          <Route path="/help/" element={<HelpingPageLayout/>}/>
          <Route path="/help/:id" element={<HelpingPageLayout/>}/>

          <Route
            exact
            path="/dashboard/projectInstructions/LayoutNewUser"
            element={<LayoutNewUser />}
          />
          <Route
            exact
            path="/dashboard/projectInstructions/FontNewUser"
            element={<FontNewUser />}
          />

          <Route path="/" element={<SurveyOutlet />}>
            <Route path="/new_user_survey" element={<SurveyForm />} /> 
          </Route>

          {/* Card Routes */}
          {/* <Route exact path="dashboard/cardLayout/:projectId" element={<CardLayout/>} /> */}
          {/* <Route exact path="dashboard/cardLayout/rendersettings/:projectId" element={<CardRender/>} /> */}
        </Route>

        <Route path="/" element={<PublicOutlet />}>
          {/* <Route exact index path="/" element={<Login />} /> */}
          <Route exact index path="/" element={<NewLogin />} />
          <Route exact index path="/login" element={<NewLogin />} />
          <Route exact path="/register" element={<NewSignup />} />
          {/* <Route exact path="/register" element={<VerifyOTPModal />} /> */}
          <Route
            exact
            path="/register/terms"
            element={<Term_and_condition />}
          />
          <Route exact path="/contactus" element={<Contactus />} />
          <Route exact path="/forgotpassword" element={<ForgotPassword />} />
          <Route exact path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Route>
      </Routes>
    </div>
  );
}
